export default __webpack_public_path__ + "static/media/doctor.f2f3b228.svg";